import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const PlusIcon = (props: IconProps) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='1.75'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M12 5l0 14' />
    <path d='M5 12l14 0' />
  </Icon>
);

export default PlusIcon;
